import { render, staticRenderFns } from "./ChannelCategoryStatuses.vue?vue&type=template&id=2b380fbd"
import script from "./ChannelCategoryStatuses.vue?vue&type=script&lang=js"
export * from "./ChannelCategoryStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports